//import { DISHES } from '../shared/dishes';
import * as ActionTypes from './ActionTypes';

export const Dishes = (state =  {
            isLoading: true,
            errMess: null,
            dishes:[]
        }, action) => {

    switch (action.type) {
// ... = sprint operator
//whatever the state is, just take the same state and then
//applied as modification to the state => return new object
        case ActionTypes.ADD_DISHES:
            return {...state, isLoading: false, errMess: null, dishes: action.payload};

        case ActionTypes.DISHES_LOADING:
            return {...state, isLoading: true, errMess: null, dishes: []}

        case ActionTypes.DISHES_FAILED:
            return {...state, isLoading: false, errMess: action.payload};

        default:
          return state;
      }
};